<ns-dialog-content>
  <ng-container *ngIf="isComposingProduct$ | async; else info">
    <ng-container *ngFor="let product of products$ | async; let $index = index">
      <bca-receipt-item
        [currentProductNumber]="$index + 1"
        [enableSelectedBox]="
          (totalProductCount$ | async) > 1 && (currentRoute$ | async) < Route.COMPANY_DATA
        "
        [totalProductCount]="totalProductCount$ | async"
        [product]="product"
        [disableEdit]="(selectedProduct$ | async)?.id === product.id"
        [isSelectedProduct]="
          (product | productSelected | async) && (currentRoute$ | async) < Route.COMPANY_DATA
        "
        (remove)="onProductDelete($event)"
        (edit)="onProductEdit($event)"
      >
      </bca-receipt-item>
    </ng-container>
      
    <hr class="articleSeparator priceSummaryLine" />
    <h2 class="headingM priceSeparation">
      <div class="gridHeader__heading">
        {{ 'FREQUENTION.MONTH_TOTAL' | translate }}
      </div>
      <div>
        <strong>€ {{ totalReceiptPrice$ | async | priceFormat }}</strong>
      </div>
    </h2>
  </ng-container>

  <ng-template #info>
    <ng-container>
      <nes-text>
        {{ 'RECEIPT.NO_SELECTION' | translate }}
      </nes-text>
      <h3 class="headingXS mt-3">
        <strong>{{ 'RECEIPT.CHOOSE_INFO' | translate }}</strong>
      </h3>
      <button disabled class="button button--nsYellow button--arrowRight">
        {{ 'BUTTON.CONTINUE_DESKTOP' | translate }}
      </button>
    </ng-container>
  </ng-template>
</ns-dialog-content>

<ns-dialog-actions *ngIf="showNextPageButton$ | async">
  <nes-button
  variant="brand"
    [cypress]="'next_page_receipt'"
    [disabled]="routeLoading$ | async"
    (click)="nextPage.emit()"
    compact
  >
    {{ nextPageButtonText | translate }}
  </nes-button>
</ns-dialog-actions>
